module.exports = __webpack_public_path__ + "img/bitkeep1.6445919b.png";